<div class="page">
  <kgrid
    #grid
    *ngIf="dataFilter && dataFilter?.length > 0"
    [apiName]="apiName"
    [areaName]="areaName"
    [label]="label"
    [name]="apiName"
    [isModal]="false"
    [isEdit]="false"
    [isAdd]="isAdd"
    reportName="AccountingList"
    pathPreFix="ACC"
    [actions]="actions"
    [useCustomDelete]="true"
    (onDelete)="DeleteAccVoucher($event)"
    [filters]="dataFilter"
    [customExportExcelUrl]="'AccVoucherHeader/ExportExcel'"
    [inputEditorform]="inputEditorform">
  </kgrid>
</div>
